import { Instance, SnapshotOut, types } from "mobx-state-tree";
import { CommonCode } from "../common-code/CommonCode";

/**
 * # AuthInfo
 * 
 * AuthInfo을 설명하세요.
 */
export const AuthInfo = types
  .model("AuthInfo")
  // --------------------------------------------------------------------------
  .props({
    authSid: types.maybeNull(types.optional(types.number, 0)),
    userSid: types.maybeNull(types.optional(types.number, 0)),
    authYn: types.maybeNull(types.optional(types.string, "")),
    userNm: types.maybeNull(types.optional(types.string, "")),
    regDt: types.maybeNull(types.optional(types.string, "")),
    updDt: types.maybeNull(types.optional(types.string, "")),
    cdssTypeCd: types.maybeNull(types.optional(CommonCode, {})),
    acntSttsCd: types.maybeNull(types.optional(CommonCode, {})),
    authType: types.maybeNull(types.optional(CommonCode, {})),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model authInfo --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IAuthInfo;
      (Object.keys(newProps) as TAuthInfoKeys[]).forEach((key) => {
        //@ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TAuthInfo = Instance<typeof AuthInfo>;
type TAuthInfoSnapshot = SnapshotOut<typeof AuthInfo>

export interface IAuthInfo extends TAuthInfo {}
export type TAuthInfoKeys = keyof TAuthInfoSnapshot & string;
export interface IAuthInfoSnapshot extends TAuthInfoSnapshot {}
export const createAuthInfo = () => 
  types.optional(AuthInfo, {
  } as TAuthInfo);
